import React, { createElement } from "react"
import { AppRouteConfig } from "@/types/navigation"

const Error404 = () => React.createElement("div", null, "404 - Page Not Found")
const Error500 = () => React.createElement("div", null, "500 - Internal Server Error")

const errorRoutes: AppRouteConfig[] = [
  {
    path: "/error/404",
    element: createElement(Error404),
    restricted: false,
    showNav: false,
    showSideBar: false,
    isError: true,
  },
  {
    path: "/error/500",
    element: createElement(Error500),
    restricted: false,
    showNav: false,
    showSideBar: false,
    isError: true,
  },
]

export default errorRoutes
